import { useEffect, useState } from 'react';

export function useIsDarkMode() {
  const getIsDark = () => document.documentElement.classList.contains('dark');
  const [isDark, setIsDark] = useState(getIsDark());

  useEffect(() => {
    const observer = new MutationObserver(() => setIsDark(getIsDark()));
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
    return () => observer.disconnect();
  }, []);

  return isDark;
} 